(ns capra.callback
  "Client-side callback registry.

   Callbacks are local JS functions that the server can invoke via :rpc/push.
   Each callback gets a unique fn-id that serializes to #rpc/fn on the wire."
  (:require
   [capra.context :as ctx]
   [capra.id :as id]))

;; Global registry: fn-id → local ClojureScript fn
(defonce ^:private registry (atom {}))

(defn make-callback
  "Register a local function as an RPC callback.
   Returns a CapraCallback that serializes to #rpc/fn when used in pipeline args."
  [local-fn]
  (let [fn-id (id/gen-id "fn")]
    (swap! registry assoc fn-id local-fn)
    (ctx/->CapraCallback fn-id local-fn)))

(defn dispatch-invocation!
  "Called by the transport when the server invokes a callback.
   msg shape: {:fn-id string :args vector}"
  [{:keys [fn-id args]}]
  (when-let [f (get @registry fn-id)]
    (apply f args)))

(defn release!
  "Remove a callback from the registry."
  [callback-or-fn-id]
  (let [fn-id (if (ctx/callback? callback-or-fn-id)
                (:fn-id callback-or-fn-id)
                callback-or-fn-id)]
    (swap! registry dissoc fn-id)))

(defn registered?
  "Check if a callback fn-id is registered."
  [fn-id]
  (contains? @registry fn-id))

(defn clear-all!
  "Clear all registered callbacks. Used on disconnect."
  []
  (reset! registry {}))
